// This file provides AMD module aliases for globally defined libraries.
// Useful when we want to load some of these modules in TypeScript

define('accounting', [], function () {
    return accounting;
});

define('jquery', [], function () {
    return $;
});

define('jqueryui', [], function () {
    return $.ui;
});

define('underscore', [], function () {
    return _;
});

define('packery', [], function () {
    return { Packery: Packery };
});

define('amcharts', [], function () {
    return { AmCharts: AmCharts };
});
